<template>
  <div class="his-q-wrap">
    <div class="his-header">推送问卷列表</div>
	<div class="table-wrap">
        <el-table :data="list.data" style="width: 100%" border @row-click="singleElection" highlight-current-row >
            <el-table-column align="center" min-width="55" label="选择问卷">
                    <template slot-scope="scope">
                        <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                        <!-- 注意：这里写 &nbsp 的目的是为了页面不显示内容，只显示单选操作 -->
                        <el-radio class="radio" v-model="list.total" :label="scope.row.id">&nbsp;</el-radio>
                    </template>
                </el-table-column>
        <el-table-column  align="center" prop="finishTime" label="创建时间"></el-table-column>
        <el-table-column  align="center" fixed="right" label="操作" width="220">
            <template slot-scope="scope">
            <div class="tab-action">
                <el-tooltip content="查看" placement="top" :enterable="false"
                ><router-link
                    target="_blank"
                    :to="{name: 'QuestForm', params: {key: scope.row.qcId}, query: { rid: scope.row.id, t: user.token }}"
                    ><i class="icon-research"></i></router-link
                ></el-tooltip>
                <el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delQuest(scope.row.id)">
                    <el-tooltip slot="reference" class="item" effect="dark" content="删除">
                        <el-button type="text" ><i class="el-icon-delete" style="font-size:20px"></i></el-button>
                    </el-tooltip>
                </el-popconfirm>
            </div>
            </template>
        </el-table-column>
        </el-table>
    </div>
    <div class="bot">
        <el-button type="primary" @click="saveHandle">确定</el-button>
    </div>

  </div>
</template>
<script>
import mixin from "@/views/mixin";
import api from "@/service/api";
import { EventBus } from '@/event-bus.js';

export default {
//   mixins: [mixin],
  props: {
    medicalRecordDetail:{
        required: true,
    },
    dictId:{
        required: true,
    },
    evalId:{
        required: true,
    }
  },
  data() {
    return {
        list: {
        current: 1,
        total: 0,
        pageSize: 0,
        data:null
      },
      currentId:null,
      user:null
    };
  },
  created() {
  this.user = JSON.parse(localStorage.getItem("user")).data;

  },
  mounted(){
    this.getData()
    console.log('1111111=======re----s',this.dictId,this.medicalRecordDetail);

  },
  methods: {
    async getData(){
        let res = await api.getEvalHistoryQ({
            dictId:this.dictId,
            inHospitalId:this.medicalRecordDetail.id
            // dictId:12,
            // inHospitalId:4881
        });
        if(res.code==1000){
            this.list.data=res.data;
        }
        console.log(res,'=======re----s',this.dictId,this.medicalRecordDetail.id);
    },
    selectionChange(selected) {
      // 覆盖掉通用的
      let selection = [];
      selected.forEach((item) => {
        selection.push(item);
      });
      this.multipleSelection = selection;
    },
    singleElection(row) {
            this.currentId = row.id;
            // this.checkList = this.tableData.filter((item) => item.id === row.id);
            console.log(`该行的编号为${row.id}`);
        },
    async saveHandle(){
        // console.log(this.evalId,'========evalId');
        
        if(!this.currentId){
            this.$message.error('请选择一条数据');
        }else{

            // this.
            let res=await api.updatePushQ({
                "evalId": this.evalId,
                "id": this.currentId
            })
            if(res.code==1000){
               setTimeout(() => {
                // this.$emit("update:detailVisible", false);
                EventBus.$emit('update-viewHisQuest','sucess')
               }, 1000);
            }
			
            console.log(res,'=======re----s');
        }
    },
    async delQuest(id){
				let res = await api.delQuestionnaireResult(id);
				if (res.code == 1000) {
					this.getData();
				}
			},
    
 }
   
};
</script>



<style lang="less" scoped>
@import '@/assets/style/var';

.his-q-wrap{
    padding: 20px 44px;
    .his-header{
        color: #616161;
        text-align: center;
        font-size: 20px;
        margin-bottom: 16px;
    }
}
.bot{
    margin-top: 32px;
    text-align: center;
}
</style>
